import React, { useState } from "react";
import { MessageSquare, PhoneCall } from "lucide-react";
import BulkSmsDialog from "./BulkSmsDialog";
import BulkAiCallDialog from "./BulkAiCallDialog";

// Compact toolbar shown above tenant lists. Operates on the currently
// filtered/visible tenants — each dialog further narrows by status within.
export default function BulkActionsBar({ tenants = [], className = "" }) {
  const [smsOpen, setSmsOpen] = useState(false);
  const [callOpen, setCallOpen] = useState(false);

  const activeCount = tenants.filter((t) => t.status === "ACTIVE").length;
  const disabled = activeCount === 0;

  return (
    <>
      <div
        className={`flex flex-wrap items-center gap-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-3 py-2 ${className}`}
      >
        <span className="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">
          Bulk actions
        </span>
        <span className="text-xs text-gray-400 dark:text-gray-500">·</span>
        <span className="text-xs text-gray-500 dark:text-gray-400">
          {activeCount} active tenant{activeCount === 1 ? "" : "s"} in view
        </span>
        <div className="ml-auto flex flex-wrap items-center gap-2">
          <button
            type="button"
            onClick={() => setSmsOpen(true)}
            disabled={disabled}
            className="inline-flex items-center gap-1.5 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-3 py-1.5 text-xs font-semibold text-gray-900 dark:text-white transition-colors duration-150 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:cursor-not-allowed disabled:opacity-40"
          >
            <MessageSquare className="h-3.5 w-3.5" />
            Bulk SMS
          </button>
          <button
            type="button"
            onClick={() => setCallOpen(true)}
            disabled={disabled}
            className="inline-flex items-center gap-1.5 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-3 py-1.5 text-xs font-semibold text-gray-900 dark:text-white transition-colors duration-150 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:cursor-not-allowed disabled:opacity-40"
          >
            <PhoneCall className="h-3.5 w-3.5" />
            Bulk AI call
          </button>
        </div>
      </div>

      <BulkSmsDialog
        open={smsOpen}
        onClose={() => setSmsOpen(false)}
        tenants={tenants}
      />
      <BulkAiCallDialog
        open={callOpen}
        onClose={() => setCallOpen(false)}
        tenants={tenants}
      />
    </>
  );
}
